/**
 * Nível hierárquico do NCM (tabela tipo_ncm). Valores correspondem a id_tipo_ncm.
 * Comprimentos do código: Capítulo=2, Posição=4, Subposição=5 ou 6, Item=7, Subitem=8.
 */
export enum TipoNcmEnum {
    Capitulo = 1,
    Posicao = 2,
    Subposicao = 3,
    Item = 4,
    SubItem = 5
}
